@if (displayView) {
  <div class="app-tutoria-container">
    <!--$ RETURN BUTTON -->
    @if (!isState(ViewState.SELECTING_STUDY_OPTION) || enableInitialArrow) {
      <div
        class="return-button"
        (click)="
          isState(ViewState.SELECTING_STUDY_OPTION)
            ? returnToHome()
            : resetChat()
        "
      >
        <img src="../../assets/images/tutoria/arrow-left.svg" />
      </div>
    }
    <!--$ OPEN CHAT HISTORY BUTTON -->
    <div class="open-chat-history-button" (click)="openHistoryChatMenu()">
      <img
        src="../../assets/images/tutoria/tutoria-open-chat-history-button.svg"
      />
    </div>
    <!--$ BANNER -->
    <div class="tutoria-banner-container">
      <div class="tutoria-banner">
        <img src="../../assets/images/tutoria/tutoria-logo.svg" />
      </div>
      @if (isState(ViewState.CHATTING) && showAiReminder) {
        <div
          class="tutoria-ai-reminder"
          [ngClass]="{ expanded: !showHistoryChatSidebar }"
        >
          <div class="tutoria-ai-reminder-message">
            <div class="tutoria-ai-reminder-icon">
              <img src="../../assets/images/tutoria/red-pin-icon.svg" />
            </div>
            <span
              >Recuerda que soy una IA y puedo cometer errores. Comprueba la
              información entregada.
            </span>
          </div>
          <div class="tutoria-ai-reminder-icon">
            <img
              src="../../assets/images/tutoria/blue-cross.svg"
              style="cursor: pointer"
              (click)="hideAiReminder()"
            />
          </div>
        </div>
      }
    </div>
    <!--$ CHATBOT APP -->
    @if (isState(ViewState.CHATTING)) {
      <div
        class="app-chatbot-container"
        [ngClass]="{ expanded: !showHistoryChatSidebar }"
      >
        <app-chatbot
          avatarPath="../../assets/images/tutoria/tutoria-agent-icon-v2.svg"
          initialMessage="Envía un mensaje"
          disabledMessage="Marie está pensando..."
          (messageHistory)="sendChatMessageHistory($event)"
          [assistantResponse]="assistantResponse"
          [disableUserInput]="disableUserInput"
          [messagesToLoad]="messagesToLoad"
        >
        </app-chatbot>
      </div>
    }
    <!--$ SELECT STUDY OPTION -->
    @if (isState(ViewState.SELECTING_STUDY_OPTION)) {
      <div
        class="tutoria-container"
        [ngClass]="{ expanded: !showHistoryChatSidebar }"
      >
        <div class="avatar-message-container">
          <img src="../../assets/images/tutoria/tutoria-agent-icon-v2.svg" />
          <div class="avatar-message">
            <p>
              ¡Hola! Soy Marie Curie. Estoy aquí para ayudarte a estudiar y
              practicar. Recuerda que soy una IA y puedo cometer errores.
              ¡Comencemos!
            </p>
          </div>
        </div>
        <div class="study-options-container">
          @for (studyOption of studyOptions; track studyOption) {
            <div class="study-option" (click)="selectStudyOption(studyOption)">
              <div class="option-icon-container">
                <img [src]="studyOption.iconPath" />
              </div>
              <span class="study-option-text">{{
                studyOption.labelVerb + ' ' + studyOption.name
              }}</span>
            </div>
          }
        </div>
      </div>
    }
    <!--$ SELECT TFL -->
    @if (isState(ViewState.SELECTING_TFL)) {
      <div
        class="tutoria-container"
        [ngClass]="{ expanded: !showHistoryChatSidebar }"
      >
        <div class="avatar-message-container">
          <img src="../../assets/images/tutoria/tutoria-agent-icon-v2.svg" />
          <div class="avatar-message">
            <p>¡Excelente! Estamos a pocos pasos de comenzar tu proyecto.</p>
          </div>
        </div>
        <div class="tfl-options-container">
          <div class="collapsable-container">
            <div
              class="collapsable-container-header"
              data-toggle="collapse"
              [attr.data-target]="'#tfl-selection'"
              aria-expanded="false"
              [attr.aria-controls]="'tfl-selection'"
              (click)="toggleSectionCollapsing('TFL')"
            >
              <img
                [ngClass]="{ rotated: isSectionCollapsed['TFL'] }"
                src="../../assets/images/tutoria/circle-dropdown-arrow.svg"
              />
              <span>Selecciona una especialidad</span>
            </div>
            <div id="tfl-selection" class="collapse show">
              <div class="collapsable-container-content">
                <div class="selectable-options">
                  @for (tfl of selectableStudySubOptions; track tfl) {
                    <div
                      class="selectable-option"
                      (click)="selectTFL(tfl)"
                      [ngClass]="{
                        selected:
                          selectedStudySubOption?.keyword === tfl.keyword,
                      }"
                    >
                      <div class="selectable-option-data">
                        <span class="selectable-option-label">{{
                          tfl.name
                        }}</span>
                      </div>
                      <img
                        class="tfl-selected"
                        [src]="
                          selectedStudySubOption.keyword === tfl.keyword
                            ? '../../assets/images/tutoria/option-selected.svg'
                            : '../../assets/images/tutoria/option-selectable.svg'
                        "
                      />
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
          <div
            class="continue-button-container"
            [ngClass]="{ expanded: !showHistoryChatSidebar }"
          >
            <button
              [ngClass]="{
                deactivated: !selectedStudySubOption.keyword,
              }"
              (click)="selectStudySubOption()"
            >
              Confirmar
            </button>
          </div>
        </div>
      </div>
    }
    <!--$ SELECT TEAMWORK TYPE AND TEAM -->
    @if (isState(ViewState.SELECTING_TEAM)) {
      <div
        class="tutoria-container"
        [ngClass]="{ expanded: !showHistoryChatSidebar }"
      >
        <div class="avatar-message-container">
          <img src="../../assets/images/tutoria/tutoria-agent-icon-v2.svg" />
          <div class="avatar-message">
            <p>Por último, ¿con quiénes estudiarás o harás este proyecto?</p>
          </div>
        </div>
        <div class="teamwork-options-container">
          <!--$ SELECT TEAMWORK TYPE -->
          <div class="collapsable-container">
            <div
              class="collapsable-container-header"
              data-toggle="collapse"
              [attr.data-target]="'#teamwork-option-content-teamwork-type'"
              aria-expanded="true"
              [attr.aria-controls]="'teamwork-option-content-teamwork-type'"
              (click)="toggleSectionCollapsing('TEAMWORK-TYPE')"
            >
              <img
                [ngClass]="{
                  rotated: isSectionCollapsed['TEAMWORK-TYPE'],
                }"
                src="../../assets/images/tutoria/circle-dropdown-arrow.svg"
              />
              <span>Selecciona una opción</span>
            </div>
            <div
              id="teamwork-option-content-teamwork-type"
              class="collapse show"
            >
              <div class="collapsable-container-content">
                <div
                  class="teamwork-type"
                  (click)="selectTeamworkType(TeamworkType.INDIVIDUAL_WORK)"
                >
                  <img
                    [src]="
                      selectedTeamworkType === TeamworkType.INDIVIDUAL_WORK
                        ? '../../assets/images/tutoria/individual-work-selected.svg'
                        : '../../assets/images/tutoria/individual-work.svg'
                    "
                  />
                  <span
                    [ngClass]="{
                      selected:
                        selectedTeamworkType === TeamworkType.INDIVIDUAL_WORK,
                    }"
                    >Solo yo</span
                  >
                </div>
                <div
                  class="teamwork-type"
                  (click)="selectTeamworkType(TeamworkType.TEAM_WORK)"
                >
                  <img
                    [src]="
                      selectedTeamworkType === TeamworkType.TEAM_WORK
                        ? '../../assets/images/tutoria/team-work-selected.svg'
                        : '../../assets/images/tutoria/team-work.svg'
                    "
                  />
                  <span
                    [ngClass]="{
                      selected: selectedTeamworkType === TeamworkType.TEAM_WORK,
                    }"
                    >En grupo</span
                  >
                </div>
              </div>
            </div>
          </div>
          <!--$ SELECT TEAM CLASSROOM -->
          @if (
            this.selectedTeamworkType === TeamworkType.TEAM_WORK &&
            this.userClassrooms.length > 1
          ) {
            <div class="collapsable-container">
              <div
                class="collapsable-container-header"
                data-toggle="collapse"
                [attr.data-target]="'#teamwork-option-content-classroom'"
                aria-expanded="true"
                [attr.aria-controls]="'teamwork-option-content-classroom'"
                (click)="toggleSectionCollapsing('CLASSROOM')"
              >
                <img
                  [ngClass]="{
                    rotated: isSectionCollapsed['CLASSROOM'],
                  }"
                  src="../../assets/images/tutoria/circle-dropdown-arrow.svg"
                />
                <span>Selecciona tu sección</span>
              </div>
              <div id="teamwork-option-content-classroom" class="collapse show">
                <div class="collapsable-container-content">
                  @for (classroom of userClassrooms; track classroom) {
                    <div
                      class="teamwork-classroom"
                      (click)="selectClassroom(classroom)"
                      [ngClass]="{
                        selected: selectedClassroom?.id === classroom.id,
                      }"
                    >
                      <span class="classroom-name">{{ classroom.name }}</span>
                      <span class="classroom-campus">{{
                        classroom.campus_name
                      }}</span>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          <!--$ SELECT TEAMMATES -->
          @if (
            this.selectedTeamworkType === TeamworkType.TEAM_WORK &&
            this.selectedClassroom
          ) {
            <div
              [ngClass]="{
                deactivated: loadingClassroomProfile,
              }"
              class="collapsable-container"
            >
              <div
                class="collapsable-container-header"
                data-toggle="collapse"
                [attr.data-target]="'#teamwork-option-content-classmates'"
                aria-expanded="false"
                [attr.aria-controls]="'teamwork-option-content-classmates'"
                (click)="toggleSectionCollapsing('CLASSMATES')"
              >
                <img
                  [ngClass]="{
                    rotated:
                      !loadingClassroomProfile &&
                      isSectionCollapsed['CLASSMATES'],
                  }"
                  [src]="
                    loadingClassroomProfile
                      ? '../../assets/images/tutoria/circle-dropdown-arrow-deactivated.svg'
                      : '../../assets/images/tutoria/circle-dropdown-arrow.svg'
                  "
                />
                <span>Selecciona tus compañeros de grupo</span>
              </div>
              <div id="teamwork-option-content-classmates" class="collapse">
                <div class="collapsable-container-content">
                  <div class="teamwork-teammates">
                    @for (index of [0, 1, 2, 3, 4]; track index) {
                      <div class="teamwork-teammate">
                        <div class="teammate-avatar-container">
                          <img
                            [src]="
                              this.selectedClassmates.length >= index
                                ? '../../assets/images/tutoria/teammate-avatar.svg'
                                : '../../assets/images/tutoria/teammate-empty.svg'
                            "
                          />
                        </div>
                        <span>{{
                          this.selectedClassmates.length >= index
                            ? getTeammateName(index)
                            : 'Nombre'
                        }}</span>
                      </div>
                    }
                  </div>
                  <div class="selectable-options">
                    @for (classmate of userClassmates; track classmate) {
                      <div
                        class="selectable-option"
                        (click)="toggleClassmateSelection(classmate)"
                        [ngClass]="{
                          selected: isTeammate(classmate),
                          blocked:
                            selectedClassmates.length >= 4 &&
                            !isTeammate(classmate),
                        }"
                      >
                        <div class="selectable-option-data">
                          <img
                            src="../../assets/images/tutoria/teammate-avatar.svg"
                          />
                          <span class="selectable-option-label">{{
                            !classmate.lastName
                              ? classmate.firstName
                              : classmate.firstName + ' ' + classmate.lastName
                          }}</span>
                        </div>
                        <img
                          class="teamwork-classmate-selected"
                          src="../../assets/images/tutoria/option-selected.svg"
                        />
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        <div
          class="continue-button-container"
          [ngClass]="{ expanded: !showHistoryChatSidebar }"
        >
          <button
            [ngClass]="{
              deactivated:
                !selectedTeamworkType ||
                (selectedTeamworkType === TeamworkType.TEAM_WORK &&
                  selectedClassmates.length === 0),
            }"
            (click)="selectTeam()"
          >
            Crear Chat
          </button>
        </div>
      </div>
    }
    <!--$ CHAT HISTORY MENU -->
    @if (showHistoryChatMenu) {
      <div
        class="chat-history-container"
        [ngClass]="{ hidden: !showHistoryChatSidebar }"
        @slideInOut
      >
        <!--* SHOW CHAT HISTORY BUTTON -->
        <div
          class="show-chat-history-button-container"
          (click)="toggleChatHistorySidebar()"
        >
          <img
            src="../../assets/images/tutoria/tutoria-chat-history-button.svg"
          />
        </div>
        <!--* BANNER -->
        <div class="chat-history-banner">
          <img
            class="chat-history-return-button"
            (click)="closeHistoryChatMenu()"
            src="../../assets/images/tutoria/arrow-right-blue.svg"
          />
          <img
            class="chat-history-cross-button"
            (click)="closeHistoryChatMenu()"
            src="../../assets/images/tutoria/blue-cross.svg"
          />
          <img
            class="chat-history-expanded-menu-cross-button"
            (click)="toggleChatHistorySidebar()"
            src="../../assets/images/tutoria/blue-cross.svg"
          />
          <div class="chat-history-banner">
            <span> Chats </span>
          </div>
        </div>
        <!--* NEW CHAT BUTTON -->
        @if (isState(ViewState.CHATTING)) {
          <div class="chat-history-new-chat-button-container">
            <div
              class="chat-history-new-chat-button"
              (click)="startNewChatSession()"
            >
              <img
                src="../../assets/images/tutoria/tutoria-new-chat-history-button.svg"
              />
              <span> Nuevo chat </span>
            </div>
          </div>
        }
        <!--* CHAT HISTORY LIST -->
        <div class="chat-history-list-container">
          @if (chatHistoryElements != null) {
            <div class="chat-history-list-title">
              <span> Más recientes </span>
            </div>
          }
          @if (chatHistoryElements != null) {
            <div class="chat-history-list">
              @for (
                chatHistoryElement of chatHistoryElements;
                track chatHistoryElement
              ) {
                <div
                  class="chat-history-list-element"
                  (click)="loadChatSession(chatHistoryElement.id)"
                  [ngClass]="{
                    selected: chatHistoryElement.id === chatSessionId,
                  }"
                >
                  <span>
                    {{ chatHistoryElement.title }}
                  </span>
                </div>
              }
              <!--TODO An actual message with format -->
              @if (!chatHistoryElements?.length) {
                <div>
                  <span class="chat-history-no-elements-message">
                    No hay historial disponible. Elige una temática para
                    comenzar tu primer chat.
                  </span>
                </div>
              }
            </div>
          }
          <!--TODO A loading circle or something? -->
          @if (chatHistoryElements == null) {
            <div>Cargando...</div>
          }
        </div>
      </div>
    }
  </div>
}
